import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { ValidateURLParams } from '@/components/validate/ValidateURLParams';
import { LoadingPage } from '@/components/dashboard/loading/loading-page';
import { useLocation } from 'react-router-dom';

import { config } from '@/config';

const metadata = { title: `${config.site.name}` };

export function Page() {
  const location = useLocation();
  return (
    <React.Fragment>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <ValidateURLParams>
        <LoadingPage />
      </ValidateURLParams>
    </React.Fragment>
  );
}
